module.exports = __webpack_public_path__ + "img/smile_danger.b3edb9d6.svg";